import DaysOfWeekControl from "./DaysOfWeekControl";
export default DaysOfWeekControl;
